module.exports = __webpack_public_path__ + "static/media/2.Foot Sprayers.62eced4d.jpg";